import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_2 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_3 = { class: "forms" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "title" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import {
  fileAvatarCreate,
  fileAvatarUpdate,
  fileAvatarDelete,
} from "@/common/api/rest/file/avatar";
import { equipmentGet, equipmentPatch } from "@/common/api/rest/equipment";

import type { EquipmentType } from "@/common/types/equipment";

import { RegisterTheme } from "@/common/themes";
import {
  baseAvatar,
  baseConfirm,
  baseModal,
  baseTable,
  iconMenu,
  svgIcon,
} from "@/common/components";
import {
  equipmentCertificatesForm,
  equipmentDetailsForm,
  equipmentForm,
} from "@/components";


export default /*@__PURE__*/_defineComponent({
  __name: '[equipment]',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const accountId = computed(() => String(route.params.id));
const equipmentId = computed(() => String(route.params.equipment));

const equipmentData = ref<EquipmentType | null>(null);

const selectedMenu = ref<string>("home");

const showDelAvatar = ref(false);

const menuTabs = computed(() => [
  {
    key: "home",
    icon: "home-line",
    label: t("common.labels.equipment"),
  },
  {
    key: "details",
    icon: "document-a",
    label: t("common.labels.details"),
  },
  {
    key: "certificate",
    icon: "certificate",
    label: t("common.labels.certificates"),
  },
]);

function back() {
  router.push(`/${accountId.value}/register/equipment`);
}

function fetchData() {
  if (!equipmentId.value) return;

  equipmentGet(accountId.value, equipmentId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        equipmentData.value = { ...data };
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function updateData(data: Partial<EquipmentType>) {
  equipmentPatch(accountId.value, equipmentId.value, data)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addAvatar(avatar: string) {
  fileAvatarCreate(accountId.value, {
    owner_id: equipmentId.value,
    type: "EQUIPMENT",
    file: avatar,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function updateAvatar(avatar: string) {
  if (!equipmentData.value.avatar) return;

  fileAvatarUpdate(accountId.value, equipmentData.value.avatar.avatar_id, {
    file: avatar,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeAvatar(avatar: string) {
  if (equipmentData.value?.avatar) {
    updateAvatar(avatar);
  } else {
    addAvatar(avatar);
  }
}

function delAvatar() {
  showDelAvatar.value = true;
}

function delAvatarConfirm() {
  if (!equipmentData.value.avatar) return;

  fileAvatarDelete(accountId.value, equipmentData.value.avatar.avatar_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        showDelAvatar.value = false;
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeMenu(key: string) {
  selectedMenu.value = key;
  fetchData();
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(RegisterTheme), { "tab-active": "equipment" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(svgIcon), {
              icon: "equipment",
              size: "2rem"
            }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.edit", { concat: _unref(t)("common.labels.equipment") })), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-back btn-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1.25rem"
            })
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(iconMenu), {
          tabs: menuTabs.value,
          active: selectedMenu.value,
          onSelected: changeMenu
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (selectedMenu.value === 'home')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("common.labels.equipment")), 1),
                    _createVNode(_unref(baseAvatar), {
                      url: equipmentData.value?.avatar?.large,
                      "is-edit": true,
                      onChange: changeAvatar,
                      onDel: _cache[1] || (_cache[1] = ($event: any) => (delAvatar()))
                    }, null, 8, ["url"]),
                    _createVNode(_unref(equipmentForm), {
                      data: equipmentData.value,
                      onUpdateData: updateData
                    }, null, 8, ["data"])
                  ], 64))
                : _createCommentVNode("", true),
              (selectedMenu.value === 'details')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("common.labels.details")), 1),
                    _createVNode(_unref(equipmentDetailsForm), {
                      data: equipmentData.value,
                      onUpdateData: updateData
                    }, null, 8, ["data"])
                  ], 64))
                : _createCommentVNode("", true),
              (selectedMenu.value === 'certificate')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("common.labels.certificates")), 1),
                    _createVNode(_unref(equipmentCertificatesForm), {
                      "account-id": accountId.value,
                      "equipment-id": equipmentId.value,
                      onUpdateData: updateData
                    }, null, 8, ["account-id", "equipment-id"])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["tabs", "active"])
      ]),
      _: 1
    }),
    _createVNode(_unref(baseConfirm), {
      show: showDelAvatar.value,
      title: _unref(t)('common.labels.remove', { concat: _unref(t)('common.labels.avatar') }),
      message: 
      _unref(t)('common.texts.remove_message', { concat: _unref(t)('common.labels.avatar') })
    ,
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (showDelAvatar.value = false)),
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (delAvatarConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})